<template>
  <v-theme-provider dark>
    <v-responsive class="grey darken-4" max-width="2500">
      <v-container fluid>
        <v-row>
          <v-col lg="2" md="12" sm="12">
            <!--  <base-info />-->
            <base-info-card title="About myeduvisa">
              <a
                class="mb-8 grey--text body-1 d-block text-none"
                href="#"
                v-html="`&rsaquo; About Us`"
              />
              <a
                class="mb-8 grey--text body-1 d-block text-none"
                href="#"
                v-html="`&rsaquo; Testimonials `"
              />
              <a
                class="mb-8 grey--text body-1 d-block text-none"
                href="#"
                v-html="`&rsaquo; Privacy Policy`"
              />
              <a
                class="mb-8 grey--text body-1 d-block text-none"
                href="#"
                v-html="`&rsaquo; Terms and conditions `"
              />
              <a
                class="mb-8 grey--text body-1 d-block text-none"
                href="#"
                v-html="`&rsaquo; Refund Policy`"
              />
            </base-info-card>
          </v-col>

          <v-col lg="3" md="12" sm="12">
            <base-info-card title="Important Sections">
              <a
                class="mb-8 grey--text body-1 d-block text-none"
                href="#"
                v-html="`&rsaquo; Canada Immigration `"
              />
              <a
                class="mb-8 grey--text body-1 d-block text-none"
                href="#"
                v-html="`&rsaquo; Australia Immigration `"
              />
              <a
                class="mb-8 grey--text body-1 d-block text-none"
                href="#"
                v-html="`&rsaquo; Study Visa`"
              />
              <a
                class="mb-8 grey--text body-1 d-block text-none"
                href="#"
                v-html="`&rsaquo; Dependent Visa `"
              />
              <a
                class="mb-8 grey--text body-1 d-block text-none"
                href="#"
                v-html="`&rsaquo; Visa Consultants`"
              />
            </base-info-card>
          </v-col>
          <v-col lg="3" md="12" sm="12">
            <base-info-card title="Eligibility Check">
              <a
                class="mb-8 grey--text body-1 d-block text-none"
                href="#"
                v-html="`&rsaquo; Canada PR Calculator `"
              />
              <a
                class="mb-8 grey--text body-1 d-block text-none"
                href="#"
                v-html="`&rsaquo; Australia PR Points `"
              />
              <a
                class="mb-8 grey--text body-1 d-block text-none"
                href="#"
                v-html="`&rsaquo; Visit Visa `"
              />
              <a
                class="mb-8 grey--text body-1 d-block text-none"
                href="#"
                v-html="`&rsaquo; Germany `"
              />
              <a
                class="mb-8 grey--text body-1 d-block text-none"
                href="#"
                v-html="`&rsaquo; Hong Kong `"
              /> </base-info-card
          ></v-col>
          <v-col lg="2" md="12" sm="12"> <info-features /></v-col>
          <v-col lg="2" md="12" sm="12">
            <base-info-card title="Contact" />

            <base-business-contact dense />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </v-theme-provider>
</template>

<script>
export default {
  name: "SectionBusinessInfo",

  components: {
    InfoFeatures: () => import("@/components/InfoFeatures"),
  },
};
</script>

<style lang="sass">
#info-alt a
  text-decoration: none
</style>
<style scoped>
.containerText {
  font-size: 13px;
}
.rowlast {
  background-color: darkgreen;
}
a {
  text-decoration: none;
}
</style>
